import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import ServerBlock from './serverBlank/ServerBlock';
import {Link} from 'react-router-dom';
import '../../styles/chooseServer.scss';
import {servers} from '../../constants/common';
import {useInitServers} from '../../hooks/useInitServers';
import {routes} from '../../constants/routes';

const ChoseServer = () => {
  const [isServerLoading, setIsServerLoading] = useState(false);
  const [searchServer, setSearchServer] = useState('');
  useInitServers();
  const {guildsGlobalState} = useSelector((state) => state.guilds);
  const [serverArr, setServerArr] = useState(guildsGlobalState?.data?.guilds);
  const [filteredServers, setFilteredServers] = useState(serverArr);

  console.log('guildsGlobalState', guildsGlobalState?.data);
  console.log('isServerLoading', isServerLoading);

  useEffect(() => {
    if (!guildsGlobalState?.data?.guilds) return;
    setServerArr(guildsGlobalState?.data?.guilds);
    setFilteredServers(guildsGlobalState?.data?.guilds);
    setIsServerLoading(true);
  }, [guildsGlobalState?.data?.guilds?.length, guildsGlobalState?.data?.guilds]);

  useEffect(() => {
    if (!serverArr) return;
    const results = serverArr?.filter((server) =>
      server.name.toLowerCase().includes(searchServer.toLowerCase()),
    );
    setFilteredServers(results);
  }, [searchServer, serverArr]);

  return (
    <div className="choose_server_wrap">
      <div className="choose_server_content">
        <div className="content_header">
          <h2>Choose a Server</h2>
          <div className="search_server_wrap">
            <div className="search_server_wrap_input">
              <label htmlFor="numId">Search:</label>
              <input
                id="numId"
                type="text"
                placeholder="Type Name or ID"
                value={searchServer}
                onChange={(e) => setSearchServer(e.target.value)}
              />
            </div>
          </div>
          <div className="recower_text_wrap">
            <p>
              Lost access?{' '}
              <span>
                {' '}
                <Link to={routes.recovery} className="recover_link">
                  {' '}
                  Recover it!{' '}
                </Link>{' '}
              </span>
            </p>
          </div>
        </div>
        <div className="content_body">
          {isServerLoading &&
          guildsGlobalState?.data?.guilds &&
          guildsGlobalState?.data?.guilds.length < 1 ? (
            <p>Oops! No Servers Found</p>
          ) : (
            <div className="content_body_server-wrap">
              {filteredServers?.map((item, idx) => (
                <ServerBlock key={idx} item={item} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChoseServer;
